import React from 'react';

const CONTACT_HERO_BG = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('contacthero.jpg')}`;

export default function ContactHero(): React.ReactElement {
  return (
    <section
      id="contact"
      className="relative isolate overflow-hidden bg-slate-900"
      style={{
        backgroundImage: `url("${CONTACT_HERO_BG}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-slate-950/60" />

      <div className="relative z-10 mx-auto flex min-h-[100vh] w-full max-w-7xl flex-col justify-end gap-8 px-4 pb-2 pt-32 sm:px-6 sm:pb-4 sm:pt-40 lg:px-12 lg:pb-6 lg:pt-48">
        <div className="max-w-3xl text-left text-white">
          <h1 className="mt-4 text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
            Get In Touch
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
            Ready to start your next project? Contact us today to discuss how we can help bring
            your engineering vision to life.
          </p>
        </div>
      </div>
    </section>
  );
}


